import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Our Approach', path: '/approach' },
    { name: 'Services', path: '/services' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Consultation', path: '/consultation' }
  ];

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-cream-light shadow-md' : 'bg-cream-light/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="text-3xl font-serif font-medium text-coral-deep hover:text-coral-medium transition-colors cursor-pointer">
            Clarion
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-all duration-300 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-coral-deep border-b-2 border-peach-warm'
                    : 'text-[#444444] hover:text-coral-medium'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button - Desktop */}
          <Link
            to="/consultation"
            className="hidden md:inline-block px-8 py-3 bg-coral-medium text-white rounded-full text-sm font-medium hover:bg-coral-deep transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Book Consultation
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-coral-deep cursor-pointer"
          >
            <i className={`text-2xl transition-transform duration-300 ${isMobileMenuOpen ? 'ri-close-line rotate-90' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div 
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-96 mt-6' : 'max-h-0'
          }`}
        >
          <div className="flex flex-col gap-4 pb-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-base font-medium py-2 transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-coral-deep font-semibold'
                    : 'text-[#444444] hover:text-coral-medium'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/consultation"
              onClick={() => setIsMobileMenuOpen(false)}
              className="inline-block px-8 py-3 bg-coral-medium text-white rounded-full text-sm font-medium hover:bg-coral-deep transition-all duration-300 text-center whitespace-nowrap cursor-pointer mt-2"
            >
              Book Consultation
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
